import React, { useState, useReducer } from 'react'
import './UploadExtratoCartao.scss'
import { Header, Segment, Grid, Divider, Form, Button, Icon, Select } from 'semantic-ui-react'

const initialFormValues = {
    restaurante: '',
    credenciadora: '',
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function UploadExtratoCartao() {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [showInicio, setShowInicio] = useState(true)
    const genderOptions = [
        { text: 'Restaurante Dom Pedro 1', value: '1' },
        { text: 'Restaurante Dom Pedro 2', value: '2' },
        { text: 'Hotel Central', value: '3' }
    ]
    const optionsCredenciadoras = []

    function handleChange(_, { name, value }) {
        setForm({ payload: { [name]: value } })
    }

    return (
        <div id='upload-extrato-cartao'>
            <Segment basic verticalAlign='middle'>
                <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                    {showInicio === true &&
                        <Grid.Column textAlign='left' style={{ maxWidth: 400 }}>
                            <Segment raised>
                                <Header>
                                    Upload de Extrato de Cartões
                                </Header>
                                <Divider />
                                <Form size='tiny'>
                                    <Form.Field
                                        label='Restaurante'
                                        control={Select}
                                        options={genderOptions}
                                        search
                                        selectOnBlur={false}
                                        placeholder='Selecionar Restaurante'
                                        name='restaurante'
                                        value={form.restaurante}
                                        onChange={handleChange}
                                    />
                                    <Form.Field
                                        label='Credenciadora'
                                        control={Select}
                                        options={optionsCredenciadoras}
                                        search
                                        selectOnBlur={false}
                                        placeholder='Selecionar Credenciadora'
                                        name='credenciadora'
                                        value={form.credenciadora}
                                        onChange={handleChange}
                                    />
                                    {/* <Form.Field>
                                        <label>N° Controle</label>
                                        <input value={form.numero} onChange={handleChange('numero')} />
                                    </Form.Field> */}
                                    <Divider clearing />
                                    <Button size='small' labelPosition='left' icon type='submit' primary onClick={() => { setShowInicio(false) }}>
                                        <Icon name='arrow right' />
                                        Enviar
                                </Button>
                                </Form>
                            </Segment>
                        </Grid.Column>
                    }
                </Grid>
            </Segment>
        </div>
    )
}